
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import TestimonialSection from './TestimonialKeyword';
import FaqSection from './FAQKeyword';
import GTag from '../components/GTag';
function Punetomumbaicarrental() {



    const cardData =
    {
        keyword: ' Pune To Mumbai Car Rental  ',
        heading: 'Mauli Cabs:  Pune To Mumbai Car Rental ',
        headingDescription: 'Mauli Cabs offers reliable and affordable Pune to Mumbai car rental services to make your travel experience smooth and hassle-free. Whether you are heading for a business meeting, a family trip, or a quick getaway, we provide a wide range of vehicles including comfortable sedans, spacious SUVs, and premium cars. Enjoy a stress-free journey with transparent pricing, professional drivers, and no hidden charges, ensuring a safe and pleasant ride between Pune and Mumbai.',

        top: 'Top Places to Visit in Mumbai with Mauli Cabs',

    "topPlaces": [
    {
        "title": "Gateway of India",
        "description": "An iconic symbol of Mumbai, the Gateway of India is a stunning arch-monument overlooking the Arabian Sea. Built in 1924, it is a popular tourist attraction and a starting point for exploring the city."
    },
    {
        "title": "Marine Drive",
        "description": "Also known as the Queen’s Necklace, Marine Drive is a 3.6-kilometer-long boulevard along the coast. It's perfect for evening walks, offering breathtaking views of the sunset and the city's glittering skyline."
    },
    {
        "title": "Chhatrapati Shivaji Maharaj Terminus",
        "description": "A UNESCO World Heritage Site, this historic railway station showcases a mix of Victorian Gothic and Indian architecture. It's a bustling hub and a masterpiece of design and craftsmanship."
    },
    {
        "title": "Elephanta Caves",
        "description": "Located on Elephanta Island, these ancient rock-cut caves feature impressive sculptures dedicated to Hindu gods, especially Lord Shiva. The island is a short ferry ride from Mumbai and offers a glimpse into ancient art and culture."
    },
    {
        "title": "Siddhivinayak Temple",
        "description": "One of Mumbai’s most revered temples, Siddhivinayak is dedicated to Lord Ganesha. Devotees from across India visit this temple to seek blessings and experience its spiritual atmosphere."
    },
    {
        "title": "Juhu Beach",
        "description": "Famous for its wide sandy shores and lively atmosphere, Juhu Beach is a favorite hangout spot for locals and tourists. It's also known for street food stalls offering classic Mumbai snacks like pav bhaji and bhel puri."
    },
    {
        "title": "Colaba Causeway",
        "description": "Colaba Causeway is a vibrant shopping street where you can find everything from clothes and jewelry to antiques. It's also home to charming cafes and historic landmarks like the Taj Mahal Palace Hotel."
    },
    {
        "title": "Haji Ali Dargah",
        "description": "Situated on an islet off the coast of Worli, Haji Ali Dargah is a beautiful mosque and tomb that attracts visitors of all faiths. It's a serene place to experience spirituality surrounded by the sea."
    },
    {
        "title": "Chor Bazaar",
        "description": "Known as the 'Thieves' Market,' Chor Bazaar is one of the largest flea markets in India. It’s a treasure trove for antique lovers, offering everything from vintage Bollywood posters to rare artifacts."
    },
    {
        "title": "Sanjay Gandhi National Park",
        "description": "A lush green escape within the city, Sanjay Gandhi National Park is home to diverse flora and fauna. Visitors can enjoy nature trails, spot wildlife, and visit the ancient Kanheri Caves located within the park."
    }
],

       "services": [
    {
        "name": "Pune to Mumbai Car Rental Service",
        "description": "Mauli Cabs offers affordable and reliable car rental services for your journey from Pune to Mumbai. Whether you're traveling solo or with a group, we have a vehicle that suits your needs."
    },
    {
        "name": "Book Pune to Mumbai Taxi",
        "description": "Book your taxi from Pune to Mumbai with Mauli Cabs. Our fleet includes a variety of vehicles to ensure a comfortable and hassle-free ride for your journey."
    },
    {
        "name": "Affordable Pune to Mumbai Car Rental",
        "description": "Looking for an affordable car rental from Pune to Mumbai? Mauli Cabs offers competitive prices without compromising on comfort and quality for a smooth ride."
    },
    {
        "name": "Private Taxi from Pune to Mumbai",
        "description": "Experience a private, comfortable ride from Pune to Mumbai with Mauli Cabs. Our professional drivers ensure a safe and timely journey with no shared rides."
    },
    {
        "name": "Luxury Taxi for Pune to Mumbai",
        "description": "Travel in style with Mauli Cabs' luxury taxis for your Pune to Mumbai journey. Choose from our premium fleet for an extra comfortable and luxurious ride."
    },
    {
        "name": "Pune to Mumbai One-Way or Round Trip",
        "description": "Whether you're planning a one-way trip or a round trip, Mauli Cabs offers flexible options for your Pune to Mumbai travel with affordable pricing and reliable services."
    },
    {
        "name": "Comfortable Taxi Ride from Pune to Mumbai",
        "description": "Mauli Cabs ensures a comfortable and smooth taxi ride from Pune to Mumbai. Our vehicles are well-maintained, and our drivers are experienced to provide a safe journey."
    },
    {
        "name": "Group Travel from Pune to Mumbai",
        "description": "Traveling with a group? Mauli Cabs offers spacious vehicles that can comfortably accommodate groups traveling from Pune to Mumbai. Enjoy a hassle-free journey together."
    },
    {
        "name": "Mumbai Trip by Taxi from Pune",
        "description": "Planning a trip to Mumbai from Pune? Book a taxi with Mauli Cabs for a stress-free and comfortable journey, whether for business or leisure."
    },
    {
        "name": "Pune to Mumbai Cab Booking Online",
        "description": "Book your Pune to Mumbai taxi online with Mauli Cabs for convenience and peace of mind. Our simple booking process ensures an easy and quick reservation for your journey."
    }
],

"tableData": [
    ["Pune to Mumbai Car Rental Service", "Book Pune to Mumbai Taxi"],
    ["Affordable Pune to Mumbai Car Rental", "Private Taxi from Pune to Mumbai"],
    ["Luxury Taxi for Pune to Mumbai", "Pune to Mumbai One-Way or Round Trip"],
    ["Comfortable Taxi Ride from Pune to Mumbai", "Group Travel from Pune to Mumbai"],
    ["Mumbai Trip by Taxi from Pune", "Pune to Mumbai Cab Booking Online"]
],



       "whychoose": [
    {
        "WhyChooseheading": "Reliable and Timely Service",
        "WhyChoosedescription": "At Mauli Cabs, we understand the importance of punctuality for your Pune to Mumbai Car Rental. Whether you're traveling for business or leisure, our drivers ensure prompt pickups and drop-offs, ensuring you reach your destination on time and stress-free."
    },
    {
        "WhyChooseheading": "Comfortable and Spacious Vehicles",
        "WhyChoosedescription": "We offer a variety of vehicles to ensure your journey is comfortable and enjoyable. From sedans to SUVs and premium cars, our fleet for Pune to Mumbai Car Rental is designed with spacious interiors, air conditioning, and plenty of legroom for your comfort."
    },
    {
        "WhyChooseheading": "Experienced and Professional Drivers",
        "WhyChoosedescription": "Our experienced drivers are experts on the Pune to Mumbai route, ensuring a smooth and safe journey. They know the best routes, traffic conditions, and safety protocols to provide you with a hassle-free and efficient ride."
    },
    {
        "WhyChooseheading": "Affordable and Transparent Pricing",
        "WhyChoosedescription": "Mauli Cabs offers competitive pricing for Pune to Mumbai Car Rental with no hidden charges. We believe in transparency, providing you with clear and honest pricing so you can relax knowing you're getting a fair deal."
    },
    {
        "WhyChooseheading": "Safe and Secure Travel",
        "WhyChoosedescription": "Your safety is our priority. Our vehicles are regularly serviced and equipped with modern safety features, including airbags, seat belts, and GPS tracking. Our professional drivers follow strict safety measures, ensuring a safe and pleasant ride between Pune and Mumbai."
    },
    {
        "WhyChooseheading": "24/7 Availability",
        "WhyChoosedescription": "Mauli Cabs is available round-the-clock for your Pune to Mumbai Car Rental needs. No matter the time of day or night, our customer service team is ready to assist you, ensuring you can book your ride at your convenience."
    },
    {
        "WhyChooseheading": "Easy and Hassle-Free Booking",
        "WhyChoosedescription": "Booking your Pune to Mumbai Car Rental with Mauli Cabs is simple and quick. You can book online through our website or mobile app, or call our customer service team for personalized assistance with your reservation."
    },
    {
        "WhyChooseheading": "Customized Travel Packages",
        "WhyChoosedescription": "Whether you're traveling for business, a family vacation, or just a quick getaway, Mauli Cabs offers customized travel packages for your Pune to Mumbai Car Rental. Tell us your preferences, and we’ll tailor the journey to suit your specific needs."
    }
]


    }




    const faqData = [
        {
            question: 'How do I book a cab from Pune to Mumbai with Mauli Cabs?',
            answer: 'Booking your cab is easy! Simply visit our website or use our mobile app. Enter Pune as your pickup location and Mumbai as your destination, then choose the vehicle that fits your needs. You can also contact our support team for assistance.',
        },
        {
            question: 'What types of cabs are available for Pune to Mumbai?',
            answer: 'Mauli Cabs offers a wide range of vehicles, including Sedans, SUVs, Ertiga, Innova Crysta, and luxury options. Choose the one that provides the best comfort for your journey.',
        },
        {
            question: 'Is the fare from Pune to Mumbai fixed?',
            answer: 'Yes, the fare is fixed and transparent. It includes tolls, taxes, and driver charges. No hidden costs—you’ll know the full price upfront.',
        },
        {
            question: 'Can I book a round trip from Pune to Mumbai?',
            answer: 'Absolutely! You can book both one-way and round-trip rides. Just provide your return details during the booking process, and we’ll handle the rest.',
        },
        {
            question: 'How long does the journey from Pune to Mumbai take?',
            answer: 'The ride from Pune to Mumbai generally takes around 3 to 3.5 hours, depending on traffic conditions. We strive to ensure a smooth and timely journey.',
        },
        {
            question: 'Are your drivers experienced with the Pune to Mumbai route?',
            answer: 'Yes, our drivers are highly experienced, well-trained, and familiar with the best routes. They ensure a safe, comfortable, and efficient journey.',
        },
        {
            question: 'Can I book a cab for airport transfers from Pune to Mumbai?',
            answer: 'Yes, Mauli Cabs offers reliable airport transfer services. Whether you need a ride to or from Mumbai’s Domestic or International Airport, we guarantee on-time arrival.',
        },
        {
            question: 'Are the cabs air-conditioned and well-maintained?',
            answer: 'Absolutely! All our cabs are air-conditioned and well-maintained for cleanliness and comfort. We take hygiene seriously and ensure your ride is pleasant.',
        },
        {
            question: 'Can I cancel or modify my booking after confirmation?',
            answer: 'Yes, you can cancel or modify your booking. Our flexible cancellation policy is available via the website or app, and our customer support team is always ready to assist you.',
        },
        {
            question: 'Why should I choose Mauli Cabs for my Pune to Mumbai trip?',
            answer: 'Mauli Cabs provides competitive pricing, a wide selection of vehicles, professional drivers, and punctual service. Whether it’s for business or leisure, we offer a comfortable, reliable, and stress-free ride.',
        },
    ];
    
    const testimonials = [
        {
            name: "Mr. Ravi Kumar",
            position: "Business Executive",
            text: "A seamless and stress-free journey from Pune to Mumbai. The ride was comfortable, and the driver was professional and friendly!",

        },
        {
            name: "Miss. Sanya Patel",
            position: "Traveler",
            text: "A wonderful experience with Mauli Cabs! The trip was quick and smooth, and I felt safe the entire time. Highly recommended!",

        },
    ];
    









    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 7972733209",
            "+91 9763272775",

        ],
        email: "booking@maulicabs.com"
    };


    const Images = [
        {
            place: "/images/keyword/1.jpg",
            text: "Pune to Mumbai Car Rental",
        },
        {
            place: "/images/keyword/2.jpg",
            text: "Pune to Shirdi Cab Booking",
        },
        {
            place: "/images/keyword/3.jpg",
            text: "Pune to Mahabaleshwar Cab",
        },
        {
            place: "/images/keyword/4.jpg",
            text: "Pune to Lonavala - Khandala Cab",
        },
        {
            place: "/images/keyword/5.jpg",
            text: "Pune to Mumbai Airport Taxi",
        },
        {
            place: "/images/keyword/6.jpg",
            text: " Pune to Adlabs Imagica Cab Booking ",
        },
        {
            place: "/images/keyword/7.jpg",
            text: "Best Cab Service For Matheran",
        },

        {
            place: "/images/keyword/8.jpg",
            text: "Pune to Ganpatipule Cab Booking",
        },

        {
            place: "/images/keyword/9.jpg",
            text: "Pune to Pandharpur Cab Booking",
        },
        {
            place: "/images/keyword/10.jpg",
            text: "Pune to Jyotirlinga Tour Package",
        },

        {
            place: "/images/keyword/11.jpg",
            text: "Pune to Ashtavinayak Darshan Cab",
        },
        {
            place: "/images/keyword/12.jpg",
            text: "Best Cab From Pune to Murud Janjira",
        },

        {
            place: "/images/keyword/13.jpg",
            text: "Pune to Alibaug Affordable Cab",
        },

        {
            place: "/images/keyword/14.jpg",
            text: "Pune to Ajanta Ellora Cab",
        },
        {
            place: "/images/keyword/15.jpg",
            text: "Pune to Aurangabad Cab Booking",
        },
        {
            place: "/images/keyword/16.jpg",
            text: "Pune to Sade Teen Shakti Peeth Cab",
        },
        {
            place: "/images/keyword/17.jpg",
            text: "Pune to Bhimashankar Round Trip",
        },
        {
            place: "/images/keyword/18.jpg",
            text: "Pune Trimbakeshwar Best Cab",
        },
        {
            place: "/images/keyword/19.jpg",
            text: "Pune to Nashik and Igatpuri Cab",
        },
        {
            place: "/images/keyword/20.jpg",
            text: " Pune to Kolhapur Cab Booking",
        },

        {
            place: "/images/keyword/22.jpg",
            text: "Pune to Satara Cab Booking",
        },
        {
            place: "/images/keyword/23.jpg",
            text: "Pune to Tarkarli - Malvan Cab",
        },
        {
            place: "/images/keyword/24.jpg",
            text: "Pune to Outstation Cab",
        },
        {
            place: "/images/keyword/25.jpg",
            text: "Pune to Goa Cab Booking",
        },
        {
            place: "/images/keyword/26.jpg",
            text: "Pune to Tuljapur Cab ",
        },
        {
            place: "/images/keyword/27.jpg",
            text: "Pune to Alandi - Dehu Darshan Cab",
        },
    ];


    const images = [
        { src: "/images/ourfleet/1.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/5.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/2.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/3.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/4.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/7.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/8.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/9.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/6.jpg", alt: "Image 1" },

    ];


   
    const jsonData = {
        "@context": "https://schema.org",
        "@type": "Product",
        "name": "Pune to Mumbai Car Rental by Mauli Cabs",
        "description": "Mauli Cabs offers reliable and affordable Pune to Mumbai car rental services. Book private or luxury taxis for one-way or round-trip travel. Choose from comfortable vehicles for solo or group travel with online booking available 24x7.",
        "aggregateRating": {
          "@type": "AggregateRating",
          "bestRating": "5",
          "worstRating": "1",
          "ratingValue": "4.8",
          "ratingCount": "6700"
        }
      };
      
     
    return (
        <div>
            <GTag/>


<Helmet>
        <title>Pune to Mumbai Car Rental | Mauli Cabs | Call +91 7972733209</title>
        <meta
          name="description"
          content="Book Pune to Mumbai car rental with Mauli Cabs. Affordable private and luxury taxis for one-way or round-trip travel. Comfortable and reliable service with 24x7 online booking."
        />
        <meta
          name="keywords"
          content="Pune to Mumbai car rental service, Book Pune to Mumbai taxi, Affordable Pune to Mumbai car rental, Private taxi from Pune to Mumbai, Luxury taxi for Pune to Mumbai, Pune to Mumbai one-way or round trip, Comfortable taxi ride from Pune to Mumbai, Group travel from Pune to Mumbai, Mumbai trip by taxi from Pune, Pune to Mumbai cab booking online"
        />
        <script type="application/ld+json">
          {JSON.stringify(jsonData)}
        </script>
      </Helmet>
      


            <section
                className="vs-breadcrumb"
                style={{ backgroundImage: 'url(/img/bg/breadcrumb-bg-2.png)' }}
            >
                <div className="container">
                    <div className="row text-center">
                        <div className="col-12">
                            <div className="breadcrumb-content">
                                <h1 className="breadcrumb-title">{cardData.keyword}</h1>
                            </div>
                        </div>
                    </div>
                </div>
            </section>





            <section>
                <div className="container-fluid" >
                    <div className="row container-fluid">
                        <div className="col-12 col-md-7 bg-foootr">
                            <img src='/images/keyword/1.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#322E77', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolorrr'>{cardData.top}</p>
                                {cardData.topPlaces.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolorrr">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolorrr">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className='px-2 bg-foootr'>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Mauli Cabs </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">

                                                <FaqSection
                                                    title="Frequently Asked"
                                                    subtitle="Help & Info"
                                                    items={faqData}
                                                />

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>


                            <TestimonialSection testimonials={testimonials} />


                            <div className='py-4'>

                                <div className="contact-box Borderr">
                                    <h3>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                            {Images.map((e) => {
                                return (
                                    <div className="box1">
                                        <a
                                            href="./"
                                            className="d-flex justify-content-around align-items-center"
                                        >
                                            <div className="b1">
                                                <img src={e.place} alt="img" />
                                            </div>
                                            <div className="b2">
                                                {" "}
                                                <a href="./" className='px-3'>{e.text}</a>
                                            </div>
                                        </a>
                                    </div>
                                );
                            })}


                            <div className="gallery-container">
                                <h2 className="gallery-title">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                            </div>

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #631D02',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#631D02' }}>
                                            <h4 className=" lead fw-semibold whitt textt-dark">Phone Numbers</h4>
                                            <i className="bi bi-telephone-fill fs-1 mb-2"></i>
                                            <div className=''>
                                                <a href="tel:+917972733209" className="d-block  text-white">+91 7972733209</a>
                                                <a href="tel:+919763272775" className="d-block  text-white">+91 9763272775</a>


                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">
                                            <i className="bi bi-envelope fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#631D02' }}>
                                                <h4 className=" fw-semibold lead whitt textt-dark">Email</h4>
                                                <a href="mailto:booking@maulicabs.com" className=" text-white d-block">
                                                    booking@maulicabs.com
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">
                                            <i className="bi bi-house-fill fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#631D02' }}>
                                                <h4 className=" fw-semibold lead whitt textt-dark">Address</h4>
                                                <p className="whit text-white ">
                                                    <i> Mauli Cabs <br />
                                                    Pune Alandi Road , Wadmukkhwadi Charholi Bk, Alandi Devachi , Khed , Pune 412105
                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>


                        </div>
                    </div>
                </div>
            </section>


        </div>
    );
}

export default Punetomumbaicarrental;